import { Calculation } from "@/components/CustomCalculations/models/Calculation";


export class QueueCustomCalculationsArgs {

    // Flattened calculations
    constructor(public readonly calculations: Array<Calculation>,
        public sortColumns: Array<string>,
        public readonly parentExecutionId?: string,
        public name?: string
    ) {
        if (calculations == null) throw Error("calculations are required");
        if (!Array.isArray(sortColumns)) throw Error("sortColumns are required");
    }

}